// Mirrors api-backend services/password_policy.py for instant feedback.
// The backend stays the authority (it also checks birthdate and the current password).
const ASCENDING = '0123456789';
const DESCENDING = '9876543210';

export function checkNewPassword(pwd: string, confirm: string): string | null {
	if (!/^\d{6,8}$/.test(pwd)) return 'A nova senha deve ter de 6 a 8 dígitos numéricos.';
	if (ASCENDING.includes(pwd) || DESCENDING.includes(pwd)) return 'A nova senha não pode ser uma sequência como 123456.';
	if (new Set(pwd).size === 1) return 'A nova senha não pode repetir o mesmo dígito.';
	if (pwd !== confirm) return 'As senhas não conferem.';
	return null;
}
